import { useMemo } from "react";
import useAuth from "../../../hooks/useAuth";

/** What Spurt reads from the suite's central login (your UserLogin). Anything missing is treated as empty, so the chat
 *  never crashes while the suite is still loading the user. */
export interface SuiteUser {
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  profilePicture: string;
  token: string;
}

interface AuthShape {
  user?: Partial<Record<keyof SuiteUser, unknown>> | null;
  logout?: () => unknown;
}

const str = (v: unknown): string => (typeof v === "string" ? v : typeof v === "number" ? String(v) : "");

export const useSuiteAuth = (): { user: SuiteUser; signedIn: boolean; logout: (() => void) | undefined } => {
  const auth = useAuth() as unknown as AuthShape;
  const u = auth.user;
  const user = useMemo<SuiteUser>(
    () => ({
      userId: str(u?.userId),
      firstName: str(u?.firstName),
      lastName: str(u?.lastName),
      email: str(u?.email),
      phone: str(u?.phone),
      profilePicture: str(u?.profilePicture),
      token: str(u?.token),
    }),
    [u?.userId, u?.firstName, u?.lastName, u?.email, u?.phone, u?.profilePicture, u?.token], // eslint-disable-line react-hooks/exhaustive-deps
  );
  const out = auth.logout;
  const logout = out ? () => void out() : undefined;
  return { user, signedIn: !!user.userId && !!user.token, logout };
};
